/* eslint no-param-reassign: "off" */
import { filterUniqueItems } from '@/helpers/unique';

import * as types from './mutation-types';

export default {
  [types.CREATE_CAMPAIGN_REQUEST]: state => {
    state.creatingCampaign = true;
    state.creatingCampaignFailed = false;
    state.creatingCampaignSucceeded = false;
  },
  [types.CREATE_CAMPAIGN_FAILURE]: (state, error) => {
    state.creatingCampaign = false;
    state.creatingCampaignFailed = true;
    state.creatingCampaignError = error;
  },
  [types.CREATE_CAMPAIGN_SUCCESS]: state => {
    state.creatingCampaign = false;
    state.creatingCampaignSucceeded = true;
    state.creatingCampaignFailed = false;
  },
  [types.GET_CAMPAIGNS_REQUEST]: state => {
    state.loadingCampaigns = true;
    state.loadingCampaignsFailed = false;
    state.loadingCampaignsSucceeded = false;
  },
  [types.GET_CAMPAIGNS_FAILURE]: (state, error) => {
    state.loadingCampaigns = false;
    state.loadingCampaignsFailed = true;
    state.loadingCampaignsError = error;
  },
  [types.GET_CAMPAIGNS_SUCCESS]: (state, response) => {
    state.loadingCampaigns = false;
    state.loadingCampaignsSucceeded = true;
    response.data.results.forEach(campaign => {
      campaign.channelLinks = null;
    });
    const newCampaigns = filterUniqueItems(state.campaigns, response.data.results, 'id');
    state.campaigns.push(...newCampaigns);
  },
  [types.CREATE_CAMPAIGN_MESSAGES_REQUEST]: state => {
    state.downloadingCampaignMessages = true;
    state.downloadingCampaignMessagesFailed = false;
    state.downloadingCampaignMessagesSucceeded = false;
  },
  [types.CREATE_CAMPAIGN_MESSAGES_FAILURE]: (state, error) => {
    state.downloadingCampaignMessages = false;
    state.downloadingCampaignMessagesFailed = true;
    state.downloadingCampaignMessagesError = error;
  },
  [types.CREATE_CAMPAIGN_MESSAGES_SUCCESS]: state => {
    state.downloadingCampaignMessages = false;
    state.downloadingCampaignMessagesSucceeded = true;
  },

  [types.CREATE_RANDOM_SELECTION_REQUEST]: state => {
    state.creatingRandomSelection = true;
    state.creatingRandomSelectionFailed = false;
    state.creatingRandomSelectionSucceeded = false;
  },
  [types.CREATE_RANDOM_SELECTION_FAILURE]: (state, error) => {
    state.creatingRandomSelection = false;
    state.creatingRandomSelectionFailed = true;
    state.creatingRandomSelectionError = error;
  },
  [types.CREATE_RANDOM_SELECTION_SUCCESS]: state => {
    state.creatingRandomSelection = false;
    state.creatingRandomSelectionSucceeded = true;
  },
  [types.GET_RANDOM_SELECTIONS_REQUEST]: state => {
    state.loadingRandomSelections = true;
    state.loadingRandomSelectionsFailed = false;
    state.loadingRandomSelectionsSucceeded = false;
  },
  [types.GET_RANDOM_SELECTIONS_FAILURE]: (state, error) => {
    state.loadingRandomSelections = false;
    state.loadingRandomSelectionsFailed = true;
    state.loadingRandomSelectionsError = error;
  },
  [types.GET_RANDOM_SELECTIONS_SUCCESS]: (state, response) => {
    state.loadingRandomSelections = false;
    state.loadingRandomSelectionsSucceeded = true;
    state.randomSelections = response.results;
  },
  [types.SET_RANDOM_SELECTIONS_WINNER_REQUEST]: (state, winner) => {
    winner.won_date = new Date().toISOString();
    state.settingRandomSelectionWinner = true;
    state.setRandomSelectionWinnerFailed = false;
    state.setRandomSelectionWinnerSucceeded = false;
  },
  [types.SET_RANDOM_SELECTIONS_WINNER_FAILURE]: (state, error) => {
    state.settingRandomSelectionWinner = false;
    state.setRandomSelectionWinnerFailed = true;
    state.setRandomSelectionWinnerError = error;
  },
  [types.SET_RANDOM_SELECTIONS_WINNER_SUCCESS]: state => {
    state.settingRandomSelectionWinner = false;
    state.setRandomSelectionWinnerSucceeded = true;
  },

  [types.GET_REPLY_MESSAGES_REQUEST]: state => {
    state.loadingReplyMessages = true;
    state.loadReplyMessagesFailed = false;
    state.loadReplyMessagesSuccess = false;
  },

  [types.GET_REPLY_MESSAGES_FAILURE]: (state, error) => {
    state.loadingReplyMessages = false;
    state.loadReplyMessagesFailed = true;
    state.loadReplyMessagesError = error;
  },

  [types.GET_REPLY_MESSAGES_SUCCESS]: (state, response) => {
    state.loadingReplyMessages = false;
    state.loadReplyMessagesSuccess = true;
    state.replyMessages.unshift(...response.data.results);
  },

  [types.GET_CAMPAIGN_DETAIL_REQUEST]: (state, id) => {
    state.loadingCampaignDetail = true;
    state.loadingCampaignDetailSucceeded = false;
    state.loadingCampaignDetailFailed = false;
    state.campaignDetail[id] = null;
  },

  [types.GET_CAMPAIGN_DETAIL_SUCCESS]: (state, data) => {
    state.loadingCampaignDetail = false;
    state.loadingCampaignDetailSucceeded = true;
    state.loadingCampaignDetailFailed = false;
    state.campaignDetail[data.id] = data;
  },

  [types.GET_CAMPAIGN_DETAIL_FAILURE]: (state, id) => {
    state.loadingCampaignDetail = false;
    state.loadingCampaignDetailSucceeded = false;
    state.loadingCampaignDetailFailed = true;
    state.campaignDetail[id] = null;
  },

  [types.SET_CAMPAIGN_FILTERS]: (state, { title, type, isActive, sortBy }) => {
    state.filterTitle = title;
    state.filterType = type;
    state.filterIsActive = isActive;
    state.filterSortBy = sortBy;
  },

  [types.SET_CAMPAIGN_PAGE]: (state, page) => {
    state.filterPage = page;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/campaign/mutations.js